import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { Tooltip } from "@mui/material";

interface Props {
  title: React.ReactNode;
}
const FailedToLoadIcon = ({ title }: Props) => {
  return (
    <Tooltip title={title} arrow disableInteractive={false}>
      <WarningRoundedIcon
        sx={(theme) => ({
          color: theme.palette.warning.light,
          fontSize: 16,
        })}
      />
    </Tooltip>
  );
};

export default FailedToLoadIcon;
